// extracted by mini-css-extract-plugin
export default {"iconError":"styles_iconError__JgO0k"};